import React from "react";
import IntakeContextPanel from "@/components/intake/IntakeContextPanel";
import CustomerIntakeSummary from "@/components/intake/companion/CustomerIntakeSummary";

/**
 * Intake Intel — bundled workshop-side surface for the FOH intake.
 *
 * Combines:
 *   1. IntakeContextPanel — captured intel (risk flags, op-prep tags,
 *      structured findings, FOH notes).  Already used on the tech inspection
 *      page; kept here so a single drop-in gives the workshop everything.
 *   2. CustomerIntakeSummary — deterministic recap sentences, retention
 *      steers, and FOH-only watch-outs (Phase 2 Expectation Engine).
 *
 * Renders nothing when `intakeSessionId` is missing — jobs created without
 * a Yestimate Intake session stay unchanged.
 *
 *   Props
 *     intakeSessionId  — string | null
 *     compact          — when true, the CustomerIntakeSummary hides the
 *                        FOH-only watch-outs (use on customer-facing
 *                        surfaces such as the FOH workspace right rail).
 */
export default function IntakeIntelTab({
  intakeSessionId,
  compact = false,
  mode = "tech",
  className = "",
}) {
  if (!intakeSessionId) return null;
  const isTester = mode === "tester";
  return (
    <div className={`space-y-3 ${className}`} data-testid="intake-intel-tab">
      <IntakeContextPanel
        intakeSessionId={intakeSessionId}
        defaultExpanded={!compact}
        mode={mode}
      />
      {/* The customer-facing recap is a FOH read-aloud artefact; testers
          never need to read it back to the customer, so hide on the
          tester surface to reduce visual noise. */}
      {!isTester && (
        <CustomerIntakeSummary
          sessionId={intakeSessionId}
          mode="live"
          testIdPrefix="intel-recap"
          showWatchOuts={!compact}
        />
      )}
    </div>
  );
}
